<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { LL } from "../../../../i18n/i18n-svelte";
    import ButtonClose from "../../Input/ButtonClose.svelte";

    export let mode: "settings" | "background";

    const dispatch = createEventDispatcher<{
        close: void;
    }>();
</script>

<div class="flex items-start gap-2 px-1">
    <div class="flex-1 flex text-xxs uppercase text-white/50 pb-0.5 pt-1 relative bold">
        <div class="group flex items-center relative z-10 w-full">
            <button
                class="btn btn-sm btn-ghost btn-light justify-center w-full rounded text-nowrap {mode === 'settings'
                    ? '!bg-white/10'
                    : ''}"
                on:click={() => {
                    mode = "settings";
                }}
            >
                {$LL.actionbar.background.settings()}
            </button>
        </div>
    </div>
    <div class="flex-1 flex text-xxs uppercase text-white/50 pb-0.5 pt-1 relative bold">
        <div class="group flex items-center relative z-10 w-full">
            <button
                class="btn btn-sm btn-ghost btn-light justify-center w-full rounded text-nowrap {mode === 'background'
                    ? '!bg-white/10'
                    : ''}"
                on:click={() => {
                    mode = "background";
                }}
            >
                {$LL.actionbar.background.cameraBackground()}
            </button>
        </div>
    </div>
    <div class="pt-1 shrink-0">
        <ButtonClose size="xs" dataTestId="closeMediaSettingsButton" on:click={() => dispatch("close")} />
    </div>
</div>
